var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyJobsIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22925 6.1125C6.22925 5.11839 7.03514 4.3125 8.02925 4.3125H14.0126C15.0067 4.3125 15.8126 5.11839 15.8126 6.1125V11.0208H8.02925C7.03513 11.0208 6.22925 10.2149 6.22925 9.22083V6.1125Z",
    stroke: "#5C678F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 12.8205C4.3125 11.8264 5.11839 11.0205 6.1125 11.0205H11.9792V18.6872H6.1125C5.11839 18.6872 4.3125 17.8813 4.3125 16.8872V12.8205Z",
    stroke: "#5C678F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 11.0205H17.8459C18.84 11.0205 19.6459 11.8264 19.6459 12.8205V16.8872C19.6459 17.8813 18.84 18.6872 17.8459 18.6872H11.9792V11.0205Z",
    stroke: "#5C678F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 11.0205V13.8955",
    stroke: "#5C678F",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14575 11.0205V13.8955",
    stroke: "#5C678F",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0208 4.3125V7.1875",
    stroke: "#5C678F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJobsIconB);
export default __webpack_public_path__ + "static/media/MyJobsIconB.0e00e22078898e86b10a7fca20750a39.svg";
export { ForwardRef as ReactComponent };